module.exports = __webpack_public_path__ + "img/quote-4-white.4ee2ae48.png";